import { render, staticRenderFns } from "./fieldset.vue?vue&type=template&id=4a1319ce&"
import script from "./fieldset.vue?vue&type=script&lang=ts&"
export * from "./fieldset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports